const nameFix = (string) => {
  if (string === 'armedforces') {
    return 'armed forces';
  }

  return string;
};

export default nameFix;
